import { connect } from 'react-redux';
import { compose, applySpec } from 'ramda';
import { withTranslation } from 'react-i18next';

import Summary from 'components/TachyReport/Summary';
import { deleteTachyReport } from 'store/actionCreators/newTachyReport';
import { getUserRole } from 'store/selectors/user';
import { downloadDocumentReferencePdf } from 'store/actionCreators/reports/singleItems';

const mapStateToProps = applySpec({
  role: getUserRole,
});

const mapDispatchToProps = (dispatch, { patientId, lastUpdated, id }) => ({
  onRemoveFile: () => {
    dispatch(deleteTachyReport(id));
  },
  onDownloadFile: () =>
    dispatch(
      downloadDocumentReferencePdf({
        url: `DocumentReference/${id}`,
        fileName: `RPM-CIED-${patientId}-tachy-${lastUpdated.substring(0, 10)}`,
      }),
    ),
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Summary);
